// extracted by mini-css-extract-plugin
export default {"user-image-container":"UserImageIcon_user-image-container__NA2BO"};